import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Tailwind className composer. SSOT — do not duplicate.
 *
 * Combines clsx (conditional class composition) with tailwind-merge
 * (resolves Tailwind utility conflicts so later classes win).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
